const columns = [
  {
    value: "ano",
    label: "Año",
    component: "select",
    context: "filter",
    excludeInView: [],
  },
  {
    value: "descripcion",
    label: "Descripción de la compra",
    component: "text",
    context: "query",
    excludeInView: [],
  },
  {
    value: "codigo_proceso",
    label: "Código del Proceso",
    component: "text",
    context: "query",
    excludeInView: ["/dashboard/pacs"],
  },
  {
    value: "pac_catalogo_electronico",
    label: "Catálogo Electrónico",
    component: "select",
    context: "filter",
    excludeInView: [
      "/dashboard/infima",
      "/dashboard/ejecutados",
      "/dashboard/transito",
    ],
  },
  {
    value: "pac_tipo",
    label: "Tipo de Contatación",
    component: "select",
    context: "filter",
    excludeInView: ["/dashboard/infima"],
  },
  {
    value: "region_entidad",
    label: "Región",
    component: "select",
    context: "filter",
    excludeInView: ["/dashboard/infima"],
  },
  {
    value: "estado",
    label: "Estado Proceso",
    component: "select",
    context: "filter",
    excludeInView: ["/dashboard/infima"],
  },
  {
    value: "provincia_entidad",
    label: "Provincia",
    component: "select",
    context: "filter",
    excludeInView: [],
  },
  {
    value: "periodo",
    label: "Periodo",
    component: "select",
    context: "filter",
    excludeInView: ["/dashboard/infima"],
  },
  {
    value: "pac_tipo_regimen",
    label: "Régimen",
    component: "select",
    context: "filter",
    excludeInView: ["/dashboard/infima"],
  },
  {
    value: "procedimiento",
    label: "Tipo de Proceso",
    component: "select",
    context: "filter",
    excludeInView: [],
  },
  {
    value: "nombre_entidad",
    label: "Entidad Contratante",
    component: "datatable",
    context: "query",
    excludeInView: [],
  },
  {
    value: "nombre_proveedor",
    label: "Nombre Proveedor",
    component: "datatable",
    context: "query",
    excludeInView: [
      "/dashboard/pacs",
      "/dashboard/transito",
      "/dashboard/infima",
    ],
  },
  {
    value: "descripcion_cpc",
    label: "CPC Nivel 5",
    component: "datatable",
    context: "query",
    excludeInView: [],
  },
  {
    value: "descripcion_cpc_full",
    label: "CPC Nivel 9",
    component: "datatable",
    context: "query",
    excludeInView: [],
  },
  {
    value: "canton_entidad",
    label: "Cantón",
    component: "datatable",
    context: "filter",
    excludeInView: [],
  },
  {
    value: "pac_total",
    label: "Presupuesto Referencial",
    component: "range",
    context: "filter",
    excludeInView: ["/dashboard/infima"],
  },
  {
    value: "pac_cantidad",
    label: "Cantidades",
    component: "range",
    context: "filter",
    excludeInView: [],
  },
  {
    value: "fecha_publicacion",
    label: "Fecha de Publicación",
    component: "range",
    valueFormat: "date",
    context: "filter",
    excludeInView: [
      "/dashboard/pacs",
      "/dashboard/ejecutados",
      "/dashboard/entidades",
      "/dashboard/proveedores",
      "/dashboard/tipos",
      "/dashboard/procedimientos",
      "/dashboard/cpc5",
      "/dashboard/cpc9",
      "/dashboard/region",
      "/dashboard/provincias",
      "/dashboard/cantones",
      "/dashboard/regimen",
      "/dashboard/periodos",
    ],
  },
  {
    value: "anticipo",
    label: "Anticipo (%)",
    component: "range",
    context: "filter",
    valueFormat: "number",
    chipLabel: "NUEVO",
    excludeInView: ["/dashboard/pacs", "/dashboard/infima"]
  },
  {
    value: "umbral_vae",
    label: "Umbral VAE",
    component: "range",
    context: "filter",
    valueFormat: "number",
    chipLabel: "NUEVO",
    excludeInView: ["/dashboard/pacs", "/dashboard/infima"]
  },
];

export function getFilterByValue(value) {
  let filter = columns.find((obj) => obj.value == value);
  console.log("filter:", filter);
  return filter;
}

export default columns;
